import { render, staticRenderFns } from "./RecepcionForm1.vue?vue&type=template&id=78347f0c&scoped=true&"
import script from "./RecepcionForm1.vue?vue&type=script&lang=js&"
export * from "./RecepcionForm1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78347f0c",
  null
  
)

export default component.exports